import React__default from 'react';
import BsContainer from 'reactstrap/lib/Container';

const Container = ({ fluid, children }) => {
    return React__default.createElement(BsContainer, { fluid: fluid }, children);
};

export { Container as default };
//# sourceMappingURL=Container.js.map
